import { createContext, useContext, useMemo, useState } from 'react';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const value = useMemo(() => ({
    openLogin: () => setLoginOpen(true),
    closeLogin: () => setLoginOpen(false),
    openRegister: () => setRegisterOpen(true),
    closeRegister: () => setRegisterOpen(false),
    openForgot: () => setForgotOpen(true),
    closeForgot: () => setForgotOpen(false)
  }), []);

  return (
    <LoginModalContext.Provider value={value}>
      {children}
      <LoginModal
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onOpenRegister={() => setRegisterOpen(true)}
        onOpenForgot={() => setForgotOpen(true)}
      />
      <RegisterModal
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        onOpenLogin={() => setLoginOpen(true)}
      />
      <ForgotPasswordModal
        open={forgotOpen}
        onClose={() => setForgotOpen(false)}
      />
    </LoginModalContext.Provider>
  );
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) {
    throw new Error('useLoginModal must be used within LoginModalProvider');
  }
  return ctx;
}

export const useAuthModal = useLoginModal;
